"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeElementMappingForCategory = exports.getElementHasntColorRef = exports.validateApplyTransformForElement = exports.getDefaultTransformForElement = exports.getDefaultCategoryTransform = exports.getDefaultColorsForElement = exports.validateColorsForElement = exports.getCategoryWithColorForElementOfSet = exports.getFirstColorEntryOfPalette = exports.findCategoryOfElementForSet = exports.hasSameCategory = exports.categoryExistsInSet = exports.elementExistsInSet = void 0;
const types_1 = require("../types");
function elementExistsInSet(resources, setId, elementId) {
    if (typeof resources.element[elementId].categories !== 'undefined') {
        for (let i = 0, len = resources.element[elementId].categories.length; i < len; i++) {
            if (categoryExistsInSet(resources, setId, resources.element[elementId].categories[i])) {
                return true;
            }
        }
    }
    return false;
}
exports.elementExistsInSet = elementExistsInSet;
function categoryExistsInSet(resources, setId, categoryId) {
    if (typeof resources.category[categoryId] !== 'undefined' &&
        typeof resources.category[categoryId].group !== 'undefined') {
        return resources.group[resources.category[categoryId].group].set === setId;
    }
    return false;
}
exports.categoryExistsInSet = categoryExistsInSet;
function hasSameCategory(resources, set, element1, element2) {
    return (findCategoryOfElementForSet(resources, element1.id, set) ===
        findCategoryOfElementForSet(resources, element2.id, set));
}
exports.hasSameCategory = hasSameCategory;
/**
 * find the real category of element to apply
 * for each element exists only one category for set
 *
 * @param resources resources where to watch
 * @param elementId element to scan
 * @param setId set of appartenence to match
 */
function findCategoryOfElementForSet(resources, elementId, setId) {
    if (resources.element[elementId].categories) {
        for (let i = 0, len = resources.element[elementId].categories.length; i < len; i++) {
            const elementCategoryId = resources.element[elementId].categories[i];
            if (resources.group[resources.category[elementCategoryId].group].set === setId)
                return elementCategoryId;
        }
    }
    throw new Error(`Element[${elementId}] has no category of set Set[${setId}], categories of element: [${resources.element[elementId].categories}]`);
}
exports.findCategoryOfElementForSet = findCategoryOfElementForSet;
/**
 * return first ColoEntry of palette sorted by order
 *
 * @param resources resources where to watch
 * @param paletteId palette to use
 */
function getFirstColorEntryOfPalette(resources, paletteId) {
    return Object.values(resources.palette[paletteId].colors).sort((a, b) => a.order - b.order)[0];
}
exports.getFirstColorEntryOfPalette = getFirstColorEntryOfPalette;
/**
 * Return a category with mapped colors
 *
 * @export
 * @param {(IResourcesMap | IPublicResources)} resources
 * @param {ElementId} elementId
 * @param {SetId} setId
 * @returns {CategoryId}
 */
function getCategoryWithColorForElementOfSet(resources, elementId, setId) {
    const categoryId = findCategoryOfElementForSet(resources, elementId, setId);
    const category = resources.category[categoryId];
    return category.dependsCategoryPalette ? [category.dependsCategoryPalette, categoryId] : [categoryId];
}
exports.getCategoryWithColorForElementOfSet = getCategoryWithColorForElementOfSet;
/**
 * Return a colors for drawable (check palette exist)
 *
 * @export
 * @param {{ [key: string]: ColorId }} colors
 * @param {(IResourcesMap | IPublicResources)} resources
 * @param {ElementId} elementId
 * @param {SetId} setId
 * @returns {{ [key: string]: ColorId }}
 */
function validateColorsForElement(colors, resources, elementId, setId) {
    if (typeof colors === 'undefined')
        return undefined;
    const result = {};
    const categoryIds = getCategoryWithColorForElementOfSet(resources, elementId, setId);
    Object.entries(colors).forEach(([mappingPaletteId, colorId]) => {
        for (let i = 0; i < categoryIds.length; i++) {
            const categoryWithColors = resources.category[categoryIds[i]];
            if (categoryWithColors.mappingPalette && categoryWithColors.mappingPalette[mappingPaletteId]) {
                const palette = resources.palette[categoryWithColors.mappingPalette[mappingPaletteId].palette];
                if (palette && palette.colors[colorId]) {
                    result[mappingPaletteId] = colorId;
                }
            }
        }
    });
    return Object.keys(result).length > 0 ? result : undefined;
}
exports.validateColorsForElement = validateColorsForElement;
/**
 * Return a default color mapping for element
 *
 * @param {IPublicResources} resources
 * @param {ElementId} elementId
 * @param {SetId} setId
 * @param {forceHasColor} forceHasColor Usata quando un elemento di una categoria ha un colore di dipendenza,
 * 										ma non nell'oggetto `drawables` non esiste l'elemento di riferimento.
 * 										Esempio: Sopracciglia dipendono da capelli, le sopracciglia sono inserite ma i capelli possono essere opzionali
 * @returns {(Record<MappingPaletteId, ColorId> | undefined)}
 */
function getDefaultColorsForElement(resources, elementId, setId, forceHasColor = false) {
    let elementCategories = [findCategoryOfElementForSet(resources, elementId, setId)];
    if (forceHasColor === false) {
        if (elementCategories.some(c => typeof resources.category[c].dependsCategoryPalette !== 'undefined'))
            return undefined;
    }
    else {
        elementCategories = getCategoryWithColorForElementOfSet(resources, elementId, setId);
    }
    const elementMappingCategory = resources.element[elementId].mappingCategoryPaletteColors;
    if (typeof elementMappingCategory !== 'undefined') {
        for (let i in elementCategories) {
            const elementCategory = elementCategories[i];
            const defaultColors = {};
            if (typeof elementMappingCategory[elementCategory] !== 'undefined') {
                const colorCategoryMappingPalette = resources.category[elementCategory].mappingPalette || {};
                Object.keys(elementMappingCategory[elementCategory]).forEach(mappingPaletteId => {
                    var _a;
                    if (mappingPaletteId && colorCategoryMappingPalette[mappingPaletteId]) {
                        const colorId = (_a = getFirstColorEntryOfPalette(resources, colorCategoryMappingPalette[mappingPaletteId].palette)) === null || _a === void 0 ? void 0 : _a.colorId;
                        if (colorId) {
                            defaultColors[mappingPaletteId] = colorId;
                        }
                    }
                });
            }
            return defaultColors;
        }
    }
}
exports.getDefaultColorsForElement = getDefaultColorsForElement;
/**
 * Return default category transform if setted
 *
 * @export
 * @param {IPublicResources} resources
 * @param {ElementId} elementId
 * @param {SetId} set
 * @returns {(IPublicTransform | undefined)}
 */
function getDefaultCategoryTransform(resources, elementId, set) {
    const categoryId = findCategoryOfElementForSet(resources, elementId, set);
    if (categoryId && resources.category[categoryId].transform)
        return resources.transform[resources.category[categoryId].transform];
}
exports.getDefaultCategoryTransform = getDefaultCategoryTransform;
/**
 * Get transform for element
 *
 * @export
 * @param {(IResourcesMap | IPublicResources)} resources
 * @param {ElementId} elementId
 * @param {SetId} setId
 * @returns {(ITransform | IPublicTransform | undefined)}
 */
function getDefaultTransformForElement(resources, elementId, setId) {
    if (resources.element[elementId].transform)
        return resources.transform[resources.element[elementId].transform];
    return getDefaultCategoryTransform(resources, elementId, setId);
}
exports.getDefaultTransformForElement = getDefaultTransformForElement;
/**
 * Sanitize apply tranform
 *
 * @export
 * @param {IApplyTransform} transform
 * @param {(IResourcesMap | IPublicResources)} resources
 * @param {ElementId} elementId
 * @param {SetId} setId
 */
function validateApplyTransformForElement(transform, resources, elementId, setId) {
    const defaultApplyTransform = types_1.ApplyTransform.default();
    if (typeof transform !== 'undefined') {
        const result = {};
        const elementTransform = getDefaultTransformForElement(resources, elementId, setId);
        if (elementTransform) {
            ;
            Object.keys(defaultApplyTransform).forEach(transformKey => {
                if (transformKey !== 'scaleIsZoom') {
                    const value = transform[transformKey];
                    const transformRange = elementTransform[transformKey];
                    if (transformRange)
                        result[transformKey] =
                            value <= transformRange.min
                                ? transformRange.min
                                : value >= transformRange.max
                                    ? transformRange.max
                                    : value;
                    else
                        result[transformKey] = defaultApplyTransform[transformKey];
                }
                else {
                    result.scaleIsZoom = elementTransform.scaleIsZoom;
                }
            });
            return result;
        }
    }
    return defaultApplyTransform;
}
exports.validateApplyTransformForElement = validateApplyTransformForElement;
/**
 *
 *
 * @export
 * @param {(IResourcesMap | IPublicResources)} resources
 * @param {ElementId} elementId
 * @param {SetId} set
 * @param {Array<IDrawableResource>} drawables
 * @returns {CategoryId}
 */
function getElementHasntColorRef(resources, elementId, set, drawables) {
    const elementCategoryForSet = resources.category[findCategoryOfElementForSet(resources, elementId, set)];
    let elementHasntColorRef = false;
    if (elementCategoryForSet.dependsCategoryPalette) {
        elementHasntColorRef =
            typeof drawables.find(e => elementId !== e.elementId &&
                elementCategoryForSet.dependsCategoryPalette &&
                getCategoryWithColorForElementOfSet(resources, e.elementId, set).includes(elementCategoryForSet.dependsCategoryPalette)) === 'undefined';
    }
    return elementHasntColorRef;
}
exports.getElementHasntColorRef = getElementHasntColorRef;
/**
 *
 * @param resources
 * @param elementId
 * @param mappingPaletteId
 * @param colorId
 * @param category
 * @returns Array<[search: string, replace: string]>
 */
function sanitizeElementMappingForCategory(resources, elementId, mappingPaletteId, colorId, categoryId) {
    const result = [];
    const element = resources.element[elementId];
    const category = resources.category[categoryId];
    const categoryMappingPalette = category.mappingPalette;
    if (categoryMappingPalette && categoryMappingPalette[mappingPaletteId]) {
        const palette = categoryMappingPalette[mappingPaletteId].palette;
        const paletteColors = resources.palette[palette].colors[colorId];
        if (paletteColors) {
            const elementMutableColors = typeof element.mappingCategoryPaletteColors !== 'undefined' && element.mappingCategoryPaletteColors[categoryId]
                ? fillColors(element.mappingCategoryPaletteColors[categoryId][mappingPaletteId], paletteColors.values.length)
                : fillColors([], paletteColors.values.length);
            paletteColors.values.forEach((color, index) => {
                if (isHEX(elementMutableColors[index])) {
                    result.push([elementMutableColors[index], color]);
                }
            });
        }
    }
    return result;
}
exports.sanitizeElementMappingForCategory = sanitizeElementMappingForCategory;
function isHEX(color) {
    return color ? color.match(/#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/gi) !== null : false;
}
function fillColors(array, len) {
    if (typeof array === 'undefined')
        array = [];
    const toFill = len - array.length;
    for (let i = 0; i < toFill; i++)
        array.push(null);
    return array;
}
